export default __webpack_public_path__ + "static/media/canal_concept@2x.72f0fa6e.png";